import * as React from 'react';
// eslint-disable-next-line import/order
import ReactDOM from 'react-dom';

import './index.css';
import { QueryClientProvider } from 'react-query';

import { queryClient } from '@/lib/react-query';

import App from './App';
import reportWebVitals from './reportWebVitals';
import { initMocks } from './test/server';
initMocks();

ReactDOM.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
